import {AfterViewInit, ChangeDetectorRef, Directive, ElementRef, Input, OnDestroy, Optional, Renderer2} from '@angular/core';
import {AbstractControl, NgControl, NgModel} from '@angular/forms';
import {ValidationService} from '../services/validation.service';
import {distinctUntilChanged, pairwise} from 'rxjs/operators';
import {Router} from '@angular/router';

@Directive({
  selector: '[formControlName]'
})
export class FormControlNameDirective implements AfterViewInit, OnDestroy {
  validation;

  constructor(public renderer: Renderer2, public router: Router, public el: ElementRef, public control: NgControl, private validationService: ValidationService) {
    this.validation = validationService;
  }

  ngAfterViewInit() {
    if (this.control.control) {
      (this.control.control as any).nativeElement = this.el.nativeElement;
      this.control.control.updateValueAndValidity();
    }
  }

  ngOnDestroy() {
    this.validation.registerControl(this.control.control, true);
  }
}
